import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app, process.env.REACT_APP_FIREBASE_STORAGE_BUCKET);

// Analytics 초기화 (브라우저 환경에서만)
// isSupported() 가 비동기라 초기화 전에 호출된 이벤트는 analyticsReady 를 기다렸다가 보낸다.
let analytics = null;
const analyticsReady = typeof window === 'undefined'
  ? Promise.resolve(null)
  : isSupported()
      .then(yes => {
        if (yes) {
          analytics = getAnalytics(app);
        }
        return analytics;
      })
      .catch(error => {
        console.error('Firebase Analytics 초기화 실패:', error);
        return null;
      });

export { storage, analytics, analyticsReady };